import { encryptToMd5 } from './string';
import { logger } from './logger';

interface SetSurvicateParams {
  idMedico: number;
  codigoValidacao: string;
}

export const setSurvicate = ({ idMedico, codigoValidacao }: SetSurvicateParams) => {
  const executeSurvicateTracking = (window: any) => {
    const run = () => {
      logger.log('track-nps', idMedico);
      //  eslint-disable-next-line
      window._sva.setVisitorTraits({
        idMedico: encryptToMd5(String(idMedico)),
        codigoValidacao,
      });
    };
    //  eslint-disable-next-line
    if (window._sva) {
      run();
      return;
    }
    window.addEventListener('SurvicateReady', run);
  };

  executeSurvicateTracking(window);
};
